Dom.addComponent(new class MessageComponent extends AbstractComponent {

  constructor() {
    super({
      name: "message",
      iframable: true,
      responsiveChildren: {
        width: false,
        height: true
      }
    });
  }

  css() {
    return `GULP-CSS-FILE-MESSAGE`;
  }

  html(props) {
    return `
      <div class="${props.sideClass}">
        <div id="slaask-bubble-list">
        </div>
      </div>
    `;
  }

  addMessage(message) {
    Dom.findById('message', 'slaask-bubble-list').insertAdjacentHTML( 'beforeend', `
      <div id="slaask-message-bubble-${message.id}" class="${Dom.componentsProps.sideClass} slaask-bubble slaask-hidden">
        <div id="slaask-message-text" class="slaask-message-text">
          <div class="slaask-message-header-wrapper">
            <b id="slaask-message-text-title" class="slaask-message-text-title"></b>
            <div id="slaask-message-header-cross" class="slaask-message-header-cross">${Svg.cross('#444444', 12)}</div>
            <br />
          </div>
          <div id="slaask-message-text-content" class="slaask-message-text-content"></div>
          <span style="color: ${this.app._window_color}" id="message-read-more" class="message-read-more slaask-hidden">${Wording.read_more}</span>
        </div>
      </div>
    `)
  }

});
